import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFaceSmile } from '@fortawesome/free-regular-svg-icons'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  maxWidth: 350,
  minWidth: 350,
  bgcolor: 'background.paper',
  borderRadius: 5,
  boxShadow: 24,
  p: 4,
  overflow: 'hidden', // added to hide overflow during animation
};

export default function Login(
  { 
    loggedIn, 
    sessionId,
    setStorageUsage,
    clientId,
    setLoggedIn,
    setAllFiles,
    addr,
    setGlobalSnackbarActive,
    setGlobalSnackbar,
    setUn,
    clearLogin,
  }) {
    
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
  
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };

  const [open, setOpen] = useState(false);
  const [showSignIn, setShowSignIn] = useState(true);
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isValidUsername, setIsValidUsername] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [disabledSignIn, setDisabledSignIn] = useState(true)
  const [loginButton, setLoginButton] = useState('Sign in')
  const [checked, setChecked] = useState(true);
  const [snackbarMessage, setSnackbarMessage]  = useState(null)

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  useEffect(()=>{
    setDisabledSignIn(false)
    setLoginButton('Sign in')
  }, [clearLogin])
// ... (your existing code)

useEffect(() => {
  if(!disabledSignIn) {
    
  setLoginButton('Sign in')
  }
}, [disabledSignIn,])
useEffect(() => {
  // Check if username or password is empty
  const isSignInDisabled = !username.trim() || !password.trim();

  // Check if username or password is invalid (you can replace this condition with your validation logic)
  const isSignInInvalid = !isValidUsername || !isValidPassword;

  // Update disabledSignIn state
  setDisabledSignIn(isSignInDisabled || isSignInInvalid);
}, [username, password, isValidUsername, isValidPassword]);



  function handleSignIn() {
    
    setLoginButton(<FontAwesomeIcon icon={faFaceSmile} spin/>)
    setDisabledSignIn(true)
    if(1 === 1) {      
      const agent = window.navigator.userAgent;
      const message = {
        type: 'signin',
        sessionId,
        clientId,
        username,
        password,
        agent,
      }
      setTimeout(async() => {
        try {
          let endpoint = `${addr}:7070`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(message)
          });
    
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
    
          // If you need to handle the response
          const responseData = await response.json();
          
          if(responseData && responseData.type) {
            if(responseData.message) {
            }
            if(responseData.type === 'success') {
              setGlobalSnackbarActive(true)
              setGlobalSnackbar(responseData.message)
              setOpenSnackbar(true)
              setSnackbarMessage('Successfully signed in 😊')
              setLoggedIn(true)
              //todo send fetch-data req
              try {
                
                const fetchReq = {
                  type: 'fetch-data',
                  sessionId,
                  clientId,
                  agent,
                }
                const response = await fetch(endpoint, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(fetchReq)
                })
                if(!response.ok ) {
                  throw new Error('Network response was not ok');                  
                }
                const responseData = await response.json();
                if(responseData && responseData.type) {
                  if(responseData.type === 'data-from-server') {
                    try {
                      setUn(responseData.username)
                      
                    setAllFiles(JSON.parse(responseData.payload))
                    const storage = JSON.parse(responseData.accountSize)
                    setStorageUsage(storage[0].storage)
                    }catch(error) {
                      console.error(error)
                    }
                  }else if(response.message) {
                    setOpenSnackbar(true)
                    setSnackbarMessage(response.message)
                  }
                }
              }
              catch(error) {
                console.error(error)
              }
            }else if(responseData.type === 'error') {
              setOpenSnackbar(true)
              setSnackbarMessage(responseData.message)
            }
          }
        } catch (error) {
          console.error('Error:', error);
        }
        
      }, 500);
    }
  }
  useEffect(() => {
    setOpen(!loggedIn);
  }, [loggedIn]);

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <div style={{display: 'flex', minHeight: 400, width: '1200px'}}>
          <div
            style={{
              display: 'flex',
              transition: 'transform 0.3s ease-in-out',
              transform: showSignIn ? 'translateX(0%)' : 'translateX(-250%)',
              height: '100%',
            }}
          >
            {/* Sign In Form */}
            <div style={{ width: '290px', height: '100%', display: 'flex', flexDirection: 'column', gap: 15 }}>
              <h2>Sign In</h2>
                <TextField
                id="username-login"
                label="Username"
                value={username}
                onChange={(e)=>{setUsername(e.target.value)}}
                />
                <TextField
                id="password-login"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: <IconButton position="end"
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>,
                  }}
                value={password}
                onChange={(e)=>{setPassword(e.target.value)}}
                />
                {disabledSignIn ? 
                
                <md-filled-button  disabled>{loginButton}</md-filled-button>
                :
                
                <md-filled-button  onClick={handleSignIn}>{loginButton}</md-filled-button>  
              }
              <span>
              Forgot password? click <a href="https://auth.donotes.app/forgot_password" style={{color: 'var(--md-sys-color-primary)'}}>
                here
              </a>
              </span>
            </div>
          </div>
          </div>
        </Box>
      </Modal>
      
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleClose}
        message={snackbarMessage}
      />
    </div>
    
  );
}
